import styled from 'styled-components'
import Image from 'next/image'

import { mq, sizes } from '../../theme'
import Breadcrumb from '../Breadcrumb'
import BoxedContainer from '../BoxedContainer'
import ActionButton from '../ActionButton'

export const Banner = styled.div`
  position: relative;
  min-height: auto;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.brownBack};
  padding: 4.5rem 0;
  @media ${mq(sizes.desktop)} {
    padding: 6rem 0;
  }
`

export const LinkButton = styled(ActionButton)`
  margin-top: 4rem;

  @media ${mq(null, sizes.tablet)} {
    margin-top: 2rem;
  }
`

export const Background = styled(Image)`
  position: absolute;
  object-fit: cover;
  height: 100%;
  width: 100%;
  inset: 0;
`

export const BannerWrapper = styled(BoxedContainer)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4rem;
  @media ${mq(sizes.tablet)} {
    flex-direction: row;
  }
`

export const Content = styled.div`
  position: relative;
  z-index: 1;
`

export const Bdc = styled(Breadcrumb)``

export const Title = styled.h1`
  ${({ theme }) => theme.textStyles.firaSans3Xl};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
  margin: 0;

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSans5Xl};
    margin: 2rem 0;
  }
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.montserratLg};
  max-width: 60rem;
  width: 100%;

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.montserratXl};
  }
`

export const ImageRight = styled(Image)``

export const ImageBlock = styled.div`
  height: 300px;
  width: 300px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7rem 3.8rem;
  @media ${mq(null, sizes.tablet)} {
    order: 1;
    margin-bottom: 2rem;
  }
`

export const Offers = styled.p`
  ${({ theme }) => theme.textStyles.montserratLg}
  font-weight: bold;
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
  margin-top: 2rem;

  @media ${mq(sizes.tablet)} {
    margin-top: 4rem;
  }
`
